import ArticleLayout from "@/components/feature/ArticleLayout";

export default function ShoesArticle() {
  return <ArticleLayout slug="pandabuy-sheet-shoes-guide" />;
}